import { AppForm } from '../../../../../../../common/forms/app.form';
import { FormControl, Validators } from '@angular/forms';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  LargeFamilyCardAppEntityLargeFamilyCardWrite
} from '../../../../../../../openapi';
import { toNumber } from '../../../../../../../services/helpers';

export class LargeFamilyForm extends AppForm {
  constructor() {
    super({
      cardIsPresent: new FormControl(false, { nonNullable: true, validators: [Validators.required] })
    });
    this.cardIsPresentChange(false);
  }

  public cardIsPresentChange(v: boolean): void {
    if (v) {
      this.removeControl('largeFamiliesTotalPersonsCount');
      this.removeControl('largeFamiliesCount');
      this.addControl(
        'cards',
        new FormControl<LargeFamilyCardAppEntityLargeFamilyCardWrite[]>([], {
          nonNullable: true,
          validators: [Validators.required, Validators.min(1), Validators.maxLength(255)]
        })
      );
    } else {
      this.removeControl('cards');
      this.addControl(
        'largeFamiliesTotalPersonsCount',
        new FormControl('', {
          nonNullable: true,
          validators: [Validators.required, Validators.min(1)]
        })
      );
      this.addControl('largeFamiliesCount', new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.min(1)]
      }));
    }
  }

  public get largeFamiliesCount(): FormControl | null {
    return this.get('largeFamiliesCount') as FormControl | null;
  }

  public get largeFamiliesTotalPersonsCount(): FormControl | null {
    return this.get('largeFamiliesTotalPersonsCount') as FormControl | null;
  }

  public get cards(): FormControl | null {
    return this.get('cards') as FormControl | null;
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead) {
    this.cardIsPresentChange(!!value?.forestHasLandRegister);
    this.cards?.setValue([...value?.largeFamilyCards || []]?.reverse());
    super.patchFormValues({
      cardIsPresent: !!value?.forestHasLandRegister,
      largeFamiliesCount: this.largeFamiliesCount ? value?.largeFamiliesCount : undefined,
      largeFamiliesTotalPersonsCount: this.largeFamiliesTotalPersonsCount ? value?.largeFamiliesTotalPersonsCount : undefined
    });
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      forestHasLandRegister: this.value.cardIsPresent,
      largeFamiliesCount: this.largeFamiliesCount ? toNumber(this.largeFamiliesCount.value) : undefined,
      largeFamiliesTotalPersonsCount: this.largeFamiliesTotalPersonsCount ? toNumber(this.largeFamiliesTotalPersonsCount.value) : undefined
    };
  }
}
